import React from 'react';
import Layout from '../../scaffolding/Layout';

const FAQ = () => {
  return <Layout>FAQ</Layout>;
};

export default FAQ;
